export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8753.7e1123cd.jpg";